
const routesDetailRegex: RegExp = new RegExp('[\'routes/\'][\\d]', 'i');
interface WindowInstance {
  customerurl: string;
  customername: string
}
const { instance: { customerurl, customername } }: { instance: WindowInstance } = window;
//@ts-ignore
export const urls = {
  intern: {
    routes: {
      main: `/${customername}routes/timeline`,
      routesmap: `/${customername}routes/routelistmap`,
      detail: (route: string): boolean => routesDetailRegex.test(route),
    }
  },
  server: {
    url: customerurl,
    dashboard: '/api/v2/metabase/token',
    auth: {
      login: '/api/v2/users/login',
      refresh: '/api/v2/users/refresh',
      logout: '/api/v2/users/logout',
      reset: 'api/v2/users/password/reset',
      activate: 'api/v2/users/activate',
      user_profile: 'api/v2/users/profile'
    },
    process: {
      processes: 'api/v2/optimizations/',
      history: 'api/v2/optimizations/',
      summary: 'api/v2/optimizations/',
      process_history: 'api/v2/optimizations/',
    },
    vehicle: 'api/v2/vehicles/',
    settings: {
      shipments: 'api/v2/settings/shipments',
      optimization: 'api/v2/settings/optimization',
      vehicle: 'api/v2/settings/vehicles/',
      territories: 'api/v2/territory/',
      postalcodes_lookup:'api/v2/postal_code/',
      frontend: 'api/v2/settings/frontend/'
    },
    loadClasses: '/api/v2/loadclass/',
  },
  support: {
    frontend: 'https://hooks.slack.com/services/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',
    backend: 'https://hooks.slack.com/services/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',
    common: 'https://hooks.slack.com/services/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',
    bugs: 'https://hooks.slack.com/services/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',
    features: 'https://hooks.slack.com/services/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',
    improvement: 'https://hooks.slack.com/services/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'
  }
};
